export default __webpack_public_path__ + "static/media/patient-dashboard-doctor.a99b2234.png";